export default __webpack_public_path__ + "static/media/XMLID_1840_.623de7e2.svg";